import templateUrl from './copyToClipboardModal.html'

/**
 *
 * @example <caption>In a controller</caption>
 * this.TmrCopyToClipboardModal($event, {
 *   textToCopy: 'SOME.TRANSLATION.KEY'}
 * });
 *
 * @alias TmrCopyToClipboardModal
 * @type {ngFactory}
 *
 * @prop {object} $event The click event passed by the template
 * @prop {string} options.textToCopy
 */
function TmrCopyToClipboardModalFactory($mdPanel) {
  'ngInject'
  return (openFrom, { textToCopy, fieldLabel = null }) => {
    let position = $mdPanel
      .newPanelPosition()
      .relativeTo(openFrom.target)
      .addPanelPosition(
        $mdPanel.xPosition.OFFSET_START,
        $mdPanel.yPosition.CENTER
      )
    let animation = $mdPanel
      .newPanelAnimation()
      .openFrom(openFrom)
      .withAnimation($mdPanel.animation.FADE)

    return $mdPanel.open({
      openFrom,
      templateUrl,
      controller: 'tmrCopyToClipboardModalController',
      controllerAs: '$ctrl',
      panelClass: 'tmr-modal tmr-copy-to-clipboard-modal md-whiteframe-1dp',
      clickOutsideToClose: true,
      escapeToClose: true,
      position,
      animation,
      locals: {
        fieldLabel,
        textToCopy,
      },
    })
  }
}

/**
 * Controller for the modal {@link TmrCopyToClipboardModal}
 *
 * @type {ngController}
 * @see TmrPromptModal
 */
export class tmrCopyToClipboardModalController {
  static ngType = 'controller'

  constructor(mdPanelRef, TmrToast) {
    'ngInject'
    Object.assign(this, { mdPanelRef, TmrToast })
  }

  $onInit() {
    this.successLabel = this.successLabel ?? 'COPYTOCLIPBOARDMODAL.SUCCESS'
    this.errorLabel = this.errorLabel ?? 'COPYTOCLIPBOARDMODAL.ERROR'
  }

  onCopy() {
    this.TmrToast.success(this.successLabel)
    return this.mdPanelRef.close()
  }

  onCopyError() {
    return this.TmrToast.error(this.errorLabel, null, null, false)
  }
}

export const factory = [
  'TmrCopyToClipboardModal',
  TmrCopyToClipboardModalFactory,
]
